import { render } from "./ViewTariffDetailTermModal.vue?vue&type=template&id=a883a450"
import script from "./ViewTariffDetailTermModal.vue?vue&type=script&lang=js"
export * from "./ViewTariffDetailTermModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__